import ErrorScreen from './Screens/ErrorScreen';
import SessionService from './SessionService';
import { UiService } from './UiService';

export default class MessageService {
    /**
     *
     * @param {any} uiMessages
     * @param {any} closingMessage
     * @param {SessionService} sessionService
     * @param {UiService} uiService
     */
    constructor(uiMessages, closingMessage, sessionService, uiService) {
        this.uiMessages = uiMessages;
        this.closingMessage = closingMessage;
        this.errorSelector = 'errors';
        this.$i = id => document.getElementById(id);
        this.sessionService = sessionService;
        this.uiService = uiService;
    }

    displayMessage(messageKey, titleKey, buttons, clearMessages, hintMessageKey) {
        const uiButtons = [];
        if (buttons) {
            if (buttons.tryAgain) {
                uiButtons.push({
                    id: 'btn-tryagain',
                    title: buttons.tryAgain.message,
                    click: buttons.tryAgain.callback
                });
            }

            if (buttons.decline) {
                uiButtons.push({
                    id: 'btn-decline',
                    title: buttons.decline.message,
                    click: buttons.decline.callback
                });
            }
        }

        //In some case we get not key, but real texts, this is why we need this fallback logic
        //TODO: refactor this fallback logic in the future
        const errorModel = {
            message: this.uiMessages[messageKey] || messageKey || 'undefined',
            title: this.uiMessages[titleKey] || titleKey || '',
            buttons: uiButtons,
            clearMessages: clearMessages || false,
            hintMessage: this.uiMessages[hintMessageKey] || hintMessageKey || 'undefined'
        };

        this.sessionService.logMessage('info', `ProviderHelper.js displayMessage: ${JSON.stringify(errorModel)}`);

        this._showError(errorModel);
    };

    displayRedirectMessage(redirectUrl, timeDelay) {
        const errorObject = {
            redirectUrl: redirectUrl || 'undefined'
        };

        this.sessionService.logMessage('info', `ProviderHelper.js displayRedirectMessage: ${JSON.stringify(errorObject)}`);

        let text = this.uiMessages.redirecting_no_delay;
        if (timeDelay > 0)
            text = this.uiMessages.redirecting.replace('{DELAY}', '<span id="seconds-remained">' + Math.round(timeDelay / 1000) + '</span>');

        text += ` ${this.uiMessages.redirect.replace('{REDIRECTURL}', redirectUrl)}`;
        text = `${this.closingMessage}<br /><br />${text}`;

        const errorModel = {
            message: text,
            title: this.uiMessages.redirect_title || '',
            clearMessages: true,
            hintMessage: 'undefined'
        };
        this._showError(errorModel);

        const counterHolder = this.$i('seconds-remained');
        if (counterHolder) {
            setInterval(function () {
                const value = parseInt(counterHolder.innerText) / 1;
                if (value > 0)
                    counterHolder.innerText = value - 1;
            }, 1000);
        }
    };

    _showError(errorModel) {
        const titleElement = this.$i('errors-title');
        const messageElement = this.$i('errors-message');
        const buttonsHolderElement = this.$i('errors-buttons-holder');

        titleElement.innerText = errorModel.title;
        buttonsHolderElement.innerHTML = '';

        if (errorModel.clearMessages) {
            messageElement.innerHTML = '';
        }

        if (messageElement.innerHTML !== '') {
            messageElement.innerHTML += '<br /><br />'
        }

        messageElement.innerHTML += errorModel.message;

        if (errorModel.hintMessage !== 'undefined') {
            this.$i('errors-hint').innerText = errorModel.hintMessage;
        }

        const errorElement = this.$i(this.errorSelector);
        if (errorModel.buttons && errorModel.buttons.length > 0) {
            errorModel.buttons.forEach(button => {
                const buttonElement = document.createElement('a');
                buttonElement.setAttribute('href', button.url || '#');
                buttonElement.innerHTML = button.title;

                if (button.click) {
                    buttonElement.addEventListener('click', button.click);
                }

                this.$i('errors-buttons-holder').appendChild(buttonElement);
            });
            errorElement.classList.remove('no-buttons');
        } else {
            errorElement.classList.add('no-buttons');
        }

        new ErrorScreen(this.uiService).display();
    };
}
